module.exports = __webpack_public_path__ + "assets/src/style/img/footer-top-dutch-talent.png?cc28a1515c40906accf510c63e805314";